/** @format */

import React, { useEffect, useState } from "react";
import { Layout, Menu, Dropdown, Space } from "antd";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { DownOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";

import logo from "../../../icons/Gerb.webp";
import halfcub from "../../../icons/halfcub.png";
import dashboard from "../../../icons/dashboard.png";
import arrowleft from "../../../icons/arrowleft.png";
import arrowright from "../../../icons/arrowright.png";
import { exit } from "../../../components/functions/Exit";
import { user_data } from "../../../components/functions/usr";

const { Header, Sider, Content } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

let sideMenu = [];

const itb = user_data() ? user_data().itb_id : 1;

sideMenu = [
    getItem(
        <NavLink to="/">Bosh sahifa</NavLink>,
        "1",
        <span role="img" className="sidebar-icon">
        <img src={dashboard} alt="404" />
      </span>
    ),

    getItem(<hr style={{ borderColor: "#eee" }} />, "just-label"),

    getItem(
        <NavLink to="asosiymanbalar">Asosiy manbalar </NavLink>,
        "11",
        <span role="img" className="sidebar-icon">
        <img src={halfcub} alt="404" />
      </span>
    ),
];

const items = [
  getItem("Profil", "1", <UserOutlined style={{ color: "#6993FF" }} />),
  {
    key: "2",
    label: (
      <span
        className=""
        style={{ fontSize: "13px" }}
        rel="noopener noreferrer"
        onClick={() => exit()}
      >
        Chiqish
      </span>
    ),
    icon: <LogoutOutlined style={{ color: "#db0909" }} />,
  },
];

const MainLayout = ({ date, setDate }) => {
  const location = useLocation();
  const [ldate, setLdate] = useState(date);
  const [collapsed, setCollapsed] = useState(false);



  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <Layout>
      <Sider width={265} trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          {collapsed ? "SM" : "SMARTWATER"}
          {React.createElement(
            collapsed
              ? () => (
                  <span
                    className="logo-icon"
                    onClick={() => setCollapsed(!collapsed)}
                  >
                    <img src={arrowright} alt="404" />
                  </span>
                )
              : () => (
                  <span
                    className="logo-icon"
                    onClick={() => setCollapsed(!collapsed)}
                  >
                    <img src={arrowleft} alt="404" />
                  </span>
                )
          )}
        </div>

        <Menu
          className="sidebar-menu upper"
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={sideMenu}
        />
      </Sider>

      <Layout className="site-layout">
        <Header
          className="site-layout-background top-menu"
          style={{ padding: 0, height: "64px" }}
          mode="horizontal"
        >
          <div className="ps-3 d-flex">
            <div>
              <img height="70%" src={logo} alt="404" />
            </div>

            <div className="ps-2 d-flex align-items-center">
              <h4
                className="m-0 text-uppercase"
                style={{ lineHeight: "20px", color: "#fff" }}
              >
                O'zbekiston Respublikasi Suv xo'jaligi vazirligi
              </h4>
            </div>
          </div>

          <div className="dropdown-style">
            <ul>
              {location.pathname === "/" ? (
                <li className="d-flex align-items-center">
                  <div className="d-flex" style={{ height: "36px" }}>
                    <input
                      className="form-control form-control-sm"
                      type="date"
                      onChange={(e) => setLdate(e.target.value)}
                      value={ldate}
                    />
                  </div>
                </li>
              ) : null}
            </ul>

            <Dropdown menu={{ items }}>
              <button
                className="btn"
                style={{ border: "#fff !important", color: "#fff" }}
                onClick={(e) => e.preventDefault()}
              >
                <Space className="dropdown-btn">
                  {JSON.parse(localStorage.getItem("sw_user")).fio}
                  <span style={{ position: "absolute", top: "20px" }}>
                    <DownOutlined />
                  </span>
                </Space>
              </button>
            </Dropdown>
          </div>
        </Header>

        <Content className="site-layout-background">
          <Outlet context={[collapsed]} />
        </Content>
      </Layout>

    </Layout>
  );
};
export default MainLayout;
